import * as t from 'io-ts';
import _ from 'lodash';

import {makeApiType} from './apiTypes';
import {LocalApplicationModel, parseLocalApplication, RLocalApplication} from './localApplicationModel';
import {parseTeammate, RTeammate} from './teammateModel';

/*
 * Runtime types.
 */

const RSearchLocalApplicationsDirty = t.readonly(
  t.type({
    items: t.readonlyArray(RLocalApplication),
    teammates: t.readonlyArray(RTeammate),
    total: t.number,
    limit: t.number,
  }),
);

/*
 * Types.
 */

export type SearchLocalApplicationModel = ReadonlyArray<LocalApplicationModel>;
export interface SearchLocalApplicationsModel extends t.TypeOf<typeof RSearchLocalApplicationsDirty> {}
export const RSearchLocalApplications = t.clean<SearchLocalApplicationsModel>(
  RSearchLocalApplicationsDirty as any,
);

/*
 * IO methods.
 */

function parseSearchLocalApplications(src: any): SearchLocalApplicationsModel {
  return {
    items: src.items.map(parseLocalApplication),
    teammates: _(src.items)
      .map((item) => (item.creator ? parseTeammate(item.creator) : undefined))
      .compact()
      .value(),
    total: src.total,
    limit: src.limit,
  };
}

/*
 * API type.
 */

export const ApiSearchLocalApplications = makeApiType(
  'localApplicationsSearch',
  RSearchLocalApplications,
  parseSearchLocalApplications,
);
